
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0IjoiRmVhdHVyZWQifQ==!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0IjoiRmVhdHVyZWQifQ==!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0Ijoi4LiH4Liy4LiZ4LmA4LiU4LmI4LiZ4LmB4LiZ4Liw4LiZ4LizIn0=!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0Ijoi4LiH4Liy4LiZ4LmA4LiU4LmI4LiZ4LmB4LiZ4Liw4LiZ4LizIn0=!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0IjoiVW5nZ3VsYW4ifQ==!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0IjoiVW5nZ3VsYW4ifQ==!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0IjoiRmVhdHVyZWQifQ==!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0IjoiRmVhdHVyZWQifQ==!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0IjoiRmVhdHVyZWQifQ==!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0IjoiRmVhdHVyZWQifQ==!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0IjoiRmVhdHVyZWQifQ==!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0IjoiRmVhdHVyZWQifQ==!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0IjoiRmVhdHVyZWQifQ==!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0IjoiRmVhdHVyZWQifQ==!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0IjoiRmVhdHVyZWQifQ==!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0IjoiRmVhdHVyZWQifQ==!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0IjoiRmVhdHVyZWQifQ==!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0IjoiRmVhdHVyZWQifQ==!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0IjoiRmVhdHVyZWQifQ==!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0IjoiRmVhdHVyZWQifQ==!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0IjoiRmVhdHVyZWQifQ==!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0IjoiRmVhdHVyZWQifQ==!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0Ijoi4LiH4Liy4LiZ4LmA4LiU4LmI4LiZ4LmB4LiZ4Liw4LiZ4LizIn0=!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0Ijoi4LiH4Liy4LiZ4LmA4LiU4LmI4LiZ4LmB4LiZ4Liw4LiZ4LizIn0=!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0IjoiVW5nZ3VsYW4ifQ==!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0IjoiVW5nZ3VsYW4ifQ==!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0IjoiW8aR4bq94bq9xIPEg+G5r8eax5rFmeG6veG6vcaMXSJ9!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJqb2ItY2FyZC1mZWF0dXJlZC10ZXh0IjoiW8aR4bq94bq9xIPEg+G5r8eax5rFmeG6veG6vcaMXSJ9!"
        )
      )
      });
  
      export { translations as default };
    